const getError = state => state.error;

const errorSelector = {getError};

export default errorSelector;
